module.exports = {
  Admin: 'access:admin',
  Member: 'access:member',
  AccountAdmin: 'access:account:admin',
};
